import React from 'react';

import { Box, Paper, Stack, type SxProps, Typography } from '@mui/material';

type Props = {
  variant: 'primary' | 'secondary';
  title: JsxNode;
  action?: JsxNode | string;
  children?: JsxNode | string;
  sx?: SxProps;
};
export default function Section({ variant = 'primary', title, action, children, sx }: Props): JsxNode {
  return (
    <Paper sx={sx}>
      <Stack
        p={2}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={variant === 'primary' ? { borderBottom: '1px solid', borderBottomColor: 'divider' } : { mb: 1 }}
      >
        <Typography variant={variant === 'primary' ? 'h3' : 'h5'} component={variant === 'primary' ? 'h2' : 'h3'}>
          {title}
        </Typography>
        {action}
      </Stack>
      <Box p={children ? 2 : 0} pt={children && variant === 'primary' ? 2 : 0}>
        {children}
      </Box>
    </Paper>
  );
}
